module.exports = __webpack_public_path__ + "static/img/person-walking.83a0f04e.svg";